import { useCallback } from 'react'
import { ApiVersion } from '../../../enums/api-version.enum'

// Encapsulates preview side-effects; expects a validate function to be passed in
export function useNotificationPreview(
    domain: any,
    notifService: { sendNotification: (domainId: any, payload: any, opts: any) => Promise<any> },
    builder: any,
    flags: any,
    campaignInfo: { campaign_id?: any; campaign_notification_type?: string },
    validateSubmit: (builder: any, domain: any, flags: any, isPreviewSend?: boolean) => Promise<boolean>,
    buildSubmittedNotificationPackages: (domain: any, builder: any, flags: any, type?: any, meta?: any) => any[],
) {
    return useCallback(
        async (type: any) => {
            const valid = await validateSubmit(builder, domain, flags, true)
            if (!valid) return

            const builds = buildSubmittedNotificationPackages(domain, builder, flags, type, campaignInfo)
            const previewBuild = builds[builder.selectedVariantIdx]

            await notifService.sendNotification(domain.id, previewBuild, {
                cancellationKey: 'notif-send-preview',
                version: ApiVersion.V4,
            })
        },
        [builder, domain, flags, campaignInfo, notifService, validateSubmit, buildSubmittedNotificationPackages],
    )
}
